export interface APIGetLoggersModel {

        Id: number;
        Serial: number;
        Site: string;
        Model: string;      // This is displayed as Product
        Channels: string;
        LastConnected: Date | null;
        AlarmState: number;
        GpsLatitude: number | null;
        GpsLongitude: number | null;
        ConfigurationId: string;
        ChannelsAvail: number | null
        SiteId: number;
        SiteName: string;
        SiteNameUserFriendly: string;
        MeterConfig: number | null
        Deployed: Date | null;

        SendToLogger: number;
        UpdateRequested: Date | null;
        UpdateConfirmed: Date | null;
        FirmwareToUpdate: number | null;
        FirmwareSent: number | null;
        FirmwareConfirmed: Date | null;
        Favourite: boolean | null
        Undeploy: boolean;
        Shutdown: boolean;
        Dormant: boolean;
        TransmissionFrequency: number | null
    Company: string;
    ModelId: string;    // This is displayed as Model

}

export function BuildApiGetLoggers(r: any): APIGetLoggersModel {
    return {
        Id: r.id,
        Serial: r.serial,
        Site: r.site,
        Model: r.model,      // This is displayed as Product
        Channels: r.channels,
        LastConnected: r.lastConnected,
        AlarmState: r.alarmState,
        GpsLatitude: r.gpsLatitude,
        GpsLongitude: r.gpsLongitude,
        ConfigurationId: r.configurationId,
        ChannelsAvail: r.channelsAvail,
        SiteId: r.siteId,
        SiteName: r.siteName,
        SiteNameUserFriendly: r.siteNameUserFriendly,
        MeterConfig: r.meterConfig,
        Deployed: r.deployed,
        SendToLogger: r.semdToLogger,
        UpdateRequested: r.updateRequested,
        UpdateConfirmed: r.updateConfirmed,
        FirmwareToUpdate: r.firmwareToUpdate,
        FirmwareSent: r.firmwareSent,
        FirmwareConfirmed: r.firmwareConfirmed,
        Favourite: null,
        Undeploy: r.undeploy,
        Shutdown:r.shutdown,
        Dormant: r.dormant,
        TransmissionFrequency: r.transmissionFrequency,
        Company: r.company,
        ModelId: r.modelId
    }
    
}